export enum ContactInformationLookupField {
  personalIdentityNumber = 'personalIdentityNumber',
  phoneNumber = 'phoneNumber',
  email = 'email',
}
